export default __webpack_public_path__ + "static/media/non_fix_icon.f0253afd.svg";